<template>
  <v-card flat rounded="lg">
    <v-card-text>
      <v-select
        label="Tipo do pedido"
        :items="getTiposPedidoCarregar()"
        :disabled="novopedido.produtos.length > 0"
        hide-details=""
        item-text="descricao"
        item-value="codigo"
        v-model="novopedido.tipoPedidoSelec"
        @change="changeSelecionaTipoPedido()"
      ></v-select>
      <template
        v-if="getTipoPedidoSelec().contrato && usuarioLogado.representante"
      >
        <saldo-contrato-vendedor
          class="mt-2"
          :codvendedor="usuarioLogado.codrepresentante"
          :saldovendedor="usuarioLogado.saldo_emis_contrato"
        ></saldo-contrato-vendedor>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import SaldoContratoVendedor from "@/components/config-conta/SaldoContratoVendedor.vue";
import { mapGetters, mapState } from "vuex";
export default {
  components: { SaldoContratoVendedor },
  computed: {
    ...mapState("pedidos", ["config", "novopedido"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  methods: {
    ...mapGetters("pedidos", ["getTipoPedidoSelec"]),
    ...mapGetters("sistema", ["device"]),
    changeSelecionaTipoPedido() {
      if (this.getTipoPedidoSelec().bonificacao) {
        this.novopedido.freteporconta = "Fábrica";
      } else {
        this.novopedido.freteporconta = "Comprador";
      }
    },
    getTiposPedidoCarregar() {
      return this.config.tipospedido.filter(
        (t) => t.dispositivo == 0 || t.dispositivo == this.device()
      );
    },
  },
};
</script>

<style>
</style>